import { createRoot } from "react-dom/client";
import { BrowserRouter } from "react-router";
import App from "./App.tsx";
import "./index.css";
// import "antd/dist/reset.css";
import RootProvider from "./providers/root.provider.tsx";
import { AppWrapper } from "./components/common/meta.tsx";

createRoot(document.getElementById("root")!).render(
  <BrowserRouter>
    <RootProvider>
      <AppWrapper>
        <App />
      </AppWrapper>
    </RootProvider>
  </BrowserRouter>
);
